import { h, FunctionComponent } from 'preact'

export const MaskIcon: FunctionComponent = () => {
  return (
    <svg width="32" height="32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.735 9.827a4 4 0 0 1 2.53 0l4.49 1.497c.544.181.912.69.912 1.265v6.822c0 .574-.368 1.084-.912 1.265l-4.49 1.497a4 4 0 0 1-2.53 0l-4.49-1.497a1.333 1.333 0 0 1-.912-1.265V12.59c0-.574.367-1.084.912-1.265l4.49-1.497Zm3.373-2.53a6.666 6.666 0 0 0-4.216 0l-4.49 1.497a3.998 3.998 0 0 0-2.282 1.945 5.335 5.335 0 0 0 0 10.522 3.999 3.999 0 0 0 2.282 1.945l4.49 1.497a6.666 6.666 0 0 0 4.216 0l4.49-1.497a3.998 3.998 0 0 0 2.282-1.945 5.335 5.335 0 0 0 0-10.522 3.998 3.998 0 0 0-2.282-1.945l-4.49-1.497Zm7.225 6.393v4.62a2.666 2.666 0 0 0 0-4.62ZM6.667 18.31v-4.62a2.666 2.666 0 0 0 0 4.62ZM20 12.667h-8v2.666h8v-2.667Zm-8 4h8v2.666h-8v-2.666Z"
        fill="#2B2D33"
      />
    </svg>
  )
}
